import { render, staticRenderFns } from "./SearchMessageItem.vue?vue&type=template&id=64c22048&scoped=true"
import script from "./SearchMessageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchMessageItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchMessageItem.vue?vue&type=style&index=0&id=64c22048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c22048",
  null
  
)

export default component.exports